/**
 * Combine all reducers in this file and export the combined reducers.
 */

import { combineReducers } from 'redux';

import languageProviderReducer from 'containers/LanguageProvider/reducer';
import authReducer from './authReducer';

/**
 * Merges the main reducer with dynamically injected reducers
 */
export default function createReducer(injectedReducers = {}) {
  const rootReducer = combineReducers({
    language: languageProviderReducer,
    auth: authReducer,
    ...injectedReducers,
  });

  return rootReducer;
}
